export const addFieldToAddress = (currentAddress, field) => {
	let address = currentAddress || '';

	if (!field) {
		return address;
	}

	address = `${address}${address ? ', ' : ''}${field}`;

	return address;
};

export const formatAddress = (wayPoint, addressFormat) => {
	let formattedAddress = '';

	const AddressKeys = {
		ADDRESS: 'address',
		STREET: 'street',
		HOUSE_NUMBER: 'house_number',
		CITY: 'city',
		STATE: 'state',
		ZIPCODE: 'zipcode',
		LOCATION_NAME: 'location_name',
		BOROUGH: 'borough'
	};

	const defaultAddressKeys = [AddressKeys.ADDRESS, AddressKeys.CITY, AddressKeys.ZIPCODE];
	const addressKeys = addressFormat?.values?.length ? addressFormat.values : defaultAddressKeys;

	addressKeys.forEach(addressKey => {
		const key = addressFormat?.values?.length ? addressKey.key : addressKey;
		if (Object.values(AddressKeys).includes(key)) {
			formattedAddress = addFieldToAddress(formattedAddress, wayPoint[key]);
		}
	});

	return formattedAddress;
};

export const formatVehicleInfo = vehicleInfo => {
	const { vehicleName, vehicleTypeTitle } = vehicleInfo || {};

	let formattedString = '';

	if (vehicleTypeTitle) {
		formattedString += ` (${vehicleTypeTitle}`;
	} else if (vehicleName) {
		formattedString += ' (';
	}

	if (vehicleName && vehicleTypeTitle) {
		formattedString += '-';
	}

	if (vehicleName) {
		formattedString += `${vehicleName})`;
	} else if (vehicleTypeTitle) {
		formattedString += ')';
	}

	return formattedString;
};
